import React from 'react'

export const BannerListPage = React.lazy(() => import('./list-banner'))
